function emptyFn() {
    console.log("this not support BroadcastChannel");
}
export const UserChannel =
    "undefined" == typeof BroadcastChannel
        ? {
              postMessage: emptyFn,
              onmessage: emptyFn,
              removeEventListener: emptyFn,
              addEventListener: emptyFn,
          }
        : new BroadcastChannel("userChannel");
